import styled from 'styled-components';
import type { DropDownWrapperProps } from '@makemydeal/dr-ui-bricks-types';

export const DropdownWrapper = styled.div<DropDownWrapperProps>`
    display: flex;
    flex-direction: column;
    width: 100%;

    & label {
        display: block;
    }
`;

export const StyledLabel = styled.label`
    width: 100%;
    height: 22px;
`;
